const layout = () => import('@/views/layout')
const orderList = () => import('@/views/order/orderList')
const chainOrderSummary = () => import('@/views/order/chainOrderSummary/index')
const advancedOrder = () => import('@/views/order/advancedOrder')
const posOrder = () => import('@/views/order/posOrder/index')

export default [
  {
    path: '/order',
    name: 'order',
    redirect: '/order/orderList',
    component: layout,
    meta: {
      title: '订单管理',
      icon: 'order.png',
      index: 6
    },
    children: [
      { path: 'orderList', name: 'orderList', component: orderList, componentName: 'order_orderList', meta: { title: `订单列表`, id: '1621000961' } },
      { path: 'advancedOrderList', name: 'advancedOrderList', component: advancedOrder, meta: { title: '预订单管理' } },
      { path: 'chainOrderSummary', name: 'chainOrderSummary', component: chainOrderSummary, meta: { title: '连锁订单汇总', id: '1621001561' } },
      { path: 'posOrder', name: 'posOrder', component: posOrder, meta: { title: 'POS订单', id: '1621001590' } },
    ]
  }
]